import React from "react"
import ContenidoNosotros from "../components/contenidoNosotros"
import Layout from '../components/layout'

const Nosotros = () => (
  <Layout>
    <ContenidoNosotros/>
  </Layout>
  
)

export default Nosotros
